import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHero } from "@/pages/HowItWorks";
import { SPORTS, SPORT_ICONS } from "@/data/sports";
import api from "@/lib/api";

export default function SportsPage() {
  const [sports, setSports] = useState(SPORTS);

  useEffect(() => {
    api.get("/sports").then(({ data }) => {
      if (data?.sports?.length) setSports(data.sports);
    }).catch(() => {});
  }, []);

  return (
    <div data-testid="sports-page">
      <PageHero eyebrow="Activities" title="One Platform. Every Sport." subtitle="From the gym to the court — find a partner for whatever moves you. More sports are added regularly." />
      <section className="py-16 md:py-24">
        <div className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {sports.map((s) => {
            const Icon = SPORT_ICONS[s.slug] || SPORT_ICONS.gym;
            return (
              <div key={s.slug} className="group relative rounded-2xl border border-zinc-800 bg-zinc-900/60 p-8 hover:border-[#E53E3E]/60 hover:-translate-y-1 transition-all" data-testid={`sport-card-${s.slug}`}>
                <span className="grid place-items-center w-14 h-14 rounded-xl bg-[#E53E3E]/10 text-[#E53E3E] group-hover:bg-[#E53E3E] group-hover:text-white transition-colors"><Icon className="w-7 h-7" /></span>
                <h3 className="mt-5 font-display text-2xl font-bold uppercase tracking-tight">{s.name}</h3>
                <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{s.description}</p>
              </div>
            );
          })}
        </div>
        <div className="text-center mt-14">
          <Link to="/get-started">
            <Button size="lg" className="bg-[#E53E3E] hover:bg-[#C53030] rounded-full font-semibold h-14 px-8">Find a Partner <ArrowRight className="w-5 h-5 ml-2" /></Button>
          </Link>
        </div>
      </section>
    </div>
  );
}
